import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Home2 from '../views/Home2.vue'
import Changelog from '../views/Changelog.vue'
import Login from '../views/Login.vue'
import Print from '../views/Print.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/zamowienia',
    name: 'Home2',
    component: Home2
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/changelog',
    name: 'Changelog',
    component: Changelog,
  },
  {
    path: '/print',
    name: 'print',
    component: Print,
    props: true,
    meta: { requiresPrintPermission: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAdmin: true }
  }


]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // Sprawdź czy trasa wymaga admina
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!loggedIn) {
      return next('/login');
    }
    const user = JSON.parse(loggedIn);
    if (user.roleId !== 3) {
      return next('/');
    }
  }

  if (to.matched.some(record => record.meta.requiresPrintPermission)) {
    if (!loggedIn) {
      return next('/login');
    }
    const user = JSON.parse(loggedIn);
    if (user.roleId === 1) {
      return next('/zamowienia');
    }
  }

  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});
export default router
